export const FETCH_QUICK_REPORT_CASES = 'src/Analyst/Cases/Bulk-Case/QuickReportBulkCase';
export const DOWNLOAD_QUICK_REPORT_CASE_SECTION_TEMPLATE = 'src/Analyst/Cases/Bulk-Case/QuickReportBulkCase/sectiontemplate';
export const FETCH_QUICK_REPORT_CASES_RESPONSE = 'src/Analyst/Cases/Bulk-Case/QuickReportBulkCase/response';
export const FETCH_QUICK_REPORT_CASES_RESPONSE_FAILURE = 'src/Analyst/Cases/Bulk-Case/QuickReportBulkCase/response_failure';
export const FETCH_PRODUCT_DETAIL_BY_PRODUCT_ID = "FETCH_PRODUCT_DETAIL_BY_PRODUCT_ID";
export const FETCH_PRODUCT_DETAIL_SUCCESS_RESPONSE = "FETCH_PRODUCT_DETAIL_SUCCESS_RESPONSE";
export const FETCH_PRODUCT_DETAIL_FAILURE_RESPONSE = "FETCH_PRODUCT_DETAIL_FAILURE_RESPONSE";
export const UPLOAD_MANUL_SECTION_DATA =  "UPLOAD_MANUL_SECTION_DATA";
export const UPLOAD_MANUL_SECTION_DATA_RESPONSE = "UPLOAD_MANUL_SECTION_DATA_RESPONSE";
export const DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_REQUEST = "DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_REQUEST";
export const DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_RESPONSE = "DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_RESPONSE";
export const DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_REQUEST = "DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_REQUEST";
export const DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_RESPONSE = "DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_RESPONSE";
export const DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_REQUEST = "DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_REQUEST";
export const DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_RESPONSE  = "DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_RESPONSE";
export const DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_REQUEST = "DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_REQUEST";
export const DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_RESPONSE =  "DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_RESPONSE";
export const DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_REQUEST = "DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_REQUEST";
export const DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_RESPONSE = "DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_RESPONSE";

export const INITIATE_OR_STOP_QUICK_CRAWLERS_REQUEST = "src/Analyst/Cases/Bulk-Case/QuickReportBulkCase/INITIATE_OR_STOP_QUICK_CRAWLERS_REQUEST";
export const INITIATE_OR_STOP_QUICK_CRAWLERS_RESPONSE = "src/Analyst/Cases/Bulk-Case/QuickReportBulkCase/INITIATE_OR_STOP_QUICK_CRAWLERS_RESPONSE";

export const fetchQuickReportCases = (data) => {
    return {
        type: FETCH_QUICK_REPORT_CASES,
        data
    }
}

export const fetchQuickReportCasesResponse = (data) => {
    return {
        type: FETCH_QUICK_REPORT_CASES_RESPONSE,
        data
    }
}

export const fetchQuickReportCasesResponseFailure = (data) => {
    return {
        type: FETCH_QUICK_REPORT_CASES_RESPONSE_FAILURE,
        data
    }
}


export const fetchProductTemplate = (data) =>{
    return {
        type : FETCH_PRODUCT_DETAIL_BY_PRODUCT_ID,
        data
    }

}


export const fetchProductDetailSuccessResponse = (data) => {
    return {
        type: FETCH_PRODUCT_DETAIL_SUCCESS_RESPONSE,
        data
    }
}


export const fetchProductDetailFailureResponse = (data) => {
    return {
        type: FETCH_PRODUCT_DETAIL_FAILURE_RESPONSE,
        data
    }
}

export const uploadManualSectionData =(data) =>{
    return {
        type : UPLOAD_MANUL_SECTION_DATA,
        data
    }
}


export const uploadManualSectionDataResponse = (data) => {
    return {
        type : UPLOAD_MANUL_SECTION_DATA_RESPONSE,
        data
    }
}


export const downloadManualSectiontemplateResponse = (data) => {
    return {
        type : DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_RESPONSE,
        data
    }
}


export const downloadManualSectiontemplateRequest = (data) => {
    return {
        type : DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_REQUEST,
        data
    }
}



export const downloadQuickReportSummaryRequest = (data) => {
    console.log(data)
    return {
        type : DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_REQUEST,
        data
    }
}



export const downloadQuickReportSummaryResponse = (data) => {
    return {
        type : DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_RESPONSE,
        data
    }
}

export const downloadQuickReportCaseCreationTemplate = (data) => {
    return{
        type : DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_REQUEST,
        data
    }
}

export const downloadQuickReportCaseCreationTemplateResponse = (data) => {
    return{
        type : DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_RESPONSE,
        data
    }
}

export const downloadQuickReportStatusFileRequest = (data) => {
    return{
        type : DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_REQUEST,
        data
    }
}


export const downloadQuickReportStatusFileResponse = (data) => {
    return { 
        type  :DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_RESPONSE,
        data
    }
}


export const downloadQuickReportCrawlerStatusFile = (data) => {
    return {
        type : DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_REQUEST,
        data
    }
}


export const downloadQuickReportCrawlerStatusFileResponse = (data) => {
    return {
        type : DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_RESPONSE,
        data
    }
}

export const initiateOrStopQuickCrawlersRequest = (data) => {
    return {
        type : INITIATE_OR_STOP_QUICK_CRAWLERS_REQUEST,
        data
    }
}

export const initiateOrStopQuickCrawlersResponse = (data) => {
    return {
        type : INITIATE_OR_STOP_QUICK_CRAWLERS_RESPONSE,
        data
    }
}